import { ref } from 'vue';
const vehicleComponents = ref([]);
export function useVehicleComponents() {
    const parseIntervalOutput = (intervalOutput) => {
        if (!intervalOutput)
            return [];
        // Keep backend-composed outputs on a single line per use.
        // Example: "Check: ... | Change: ..." should remain one usage entry.
        const normalized = intervalOutput.replace(/\\\//g, '/').trim();
        if (!normalized)
            return [];
        const firstColon = normalized.indexOf(':');
        if (firstColon === -1) {
            return [{
                    intervalType: '',
                    intervalName: normalized,
                }];
        }
        return [{
                intervalType: normalized.slice(0, firstColon).trim(),
                intervalName: normalized.slice(firstColon + 1).trim(),
            }];
    };
    const mapUseToUsage = (useName, intervalOutput) => {
        const intervals = parseIntervalOutput(intervalOutput);
        return intervals.map(interval => ({
            title: useName,
            intervalName: interval.intervalName,
            intervalType: interval.intervalType,
        }));
    };
    const setVehicleComponents = (components) => {
        const normalized = (components || []).map((component, index) => {
            const codes = (component.componentCodes || []).map((codeItem) => {
                const capacities = (codeItem.capacities || []).map((cap) => ({
                    title: cap.title || cap.capacitiesItem || cap.item || '',
                    value: cap.value || cap.capacityValue || '',
                    mobileValue: cap.mobileValue || '',
                    unit: cap.unit || cap.capacityUnit || '',
                }));
                const optionGroups = codeItem.options || null;
                const baseProducts = codeItem.product_recommendations || codeItem.productRecommendations || [];
                const baseUsage = codeItem.uses
                    ? codeItem.uses.flatMap((u) => mapUseToUsage(u.useName, u.intervalOutput))
                    : mapUseToUsage(codeItem.useName || '', codeItem.intervalOutput || '');
                const productGroups = optionGroups
                    ? optionGroups.map((option) => {
                        const groupUsage = (option.uses || []).flatMap((u) => mapUseToUsage(u.useName, u.intervalOutput));
                        return {
                            group: option.optionNumber || 1,
                            usage: groupUsage,
                            products: (option.product_recommendations || []).map((product) => ({
                                id: product.productCode,
                                title: product.productName,
                                url: product.url || '#',
                                image: product.image || '',
                                hexcode: product.hexcode || '#00264C',
                                is_oem_approved: false,
                                recommended_usage_col_1: product.recommended_usage_col_1 || '',
                                recommended_usage_col_2: product.recommended_usage_col_2 || '',
                                recommended_usage_col_3: product.recommended_usage_col_3 || '',
                                use_name: '',
                                use_app_order: 0,
                                intervals: [],
                            })),
                        };
                    })
                    : [{
                            group: 1,
                            usage: baseUsage,
                            products: baseProducts.map((product) => ({
                                id: product.productCode || product.code,
                                title: product.productName || product.name,
                                url: product.url || '#',
                                image: product.image || '',
                                hexcode: product.hexcode || '#00264C',
                                is_oem_approved: false,
                                recommended_usage_col_1: product.recommended_usage_col_1 || '',
                                recommended_usage_col_2: product.recommended_usage_col_2 || '',
                                recommended_usage_col_3: product.recommended_usage_col_3 || '',
                                use_name: '',
                                use_app_order: 0,
                                intervals: [],
                            })),
                        }];
                return {
                    code: codeItem.code || '',
                    capacities,
                    usage: baseUsage,
                    productGroups,
                };
            });
            return {
                id: `component-${index}-${String(component.componentName || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
                title: component.componentName,
                codes,
                capacities: codes[0]?.capacities || [],
            };
        });
        vehicleComponents.value = normalized;
    };
    const clearVehicleComponents = () => {
        vehicleComponents.value = [];
    };
    return {
        vehicleComponents,
        setVehicleComponents,
        clearVehicleComponents
    };
}
